import { t } from "i18next";
import FormikATextField from "../../components/HangingProtocol/FormikATextField";
import { Accordion, AccordionItem, AccordionHeader, AccordionPanel } from "@fluentui/react-accordion";
import { FormikProvider, Form, FieldArray, Field } from "formik";
import {SpinButton} from "@fluentui/react";
import Viewport from "./Viewport";
import "./layout.css";
import { ACTIONS, HP_VIEWPORT_FLIP, HP_VIEWPORT_ALIGNMENT } from "../../constants/Constants";
import { getIn } from 'formik';
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

const Layout = (props) => {

const ViewportCntTextField = ({ field, form, viewportList, updateViewportList, ...props }) => {

  const customSpinButtonStyles = {
    root: {
      width: '86px', // Apply width to the root element
    },
    input: {
      backgroundColor: 'transparent', // Change the input background color
    },
  };

  const handleKeyDown = (e) => {
    const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"];

    // Allow replacing the digit if text is selected
    const isReplacing = window.getSelection().toString().length > 0;
    // If not replacing and a digit is already entered, prevent more numbers
    if (!isReplacing && ["1", "2", "3"].includes(e.key) && e.target.value.length >= 1) {
      e.preventDefault();
      return;
    }
    // Allow only "1", "2", "3" and necessary keys
    if (!["1", "2", "3"].includes(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const onChange = (event, newValue) => {
    if(newValue === undefined || newValue <=0 || newValue > 3)
      return;
    form.setFieldValue(field.name, newValue);
    let rows = 1;
    let columns = 1;
    if(field.name === "layout.rows") {
      rows = newValue;
      columns = form.values.layout.columns || 1;
    } else if(field.name === "layout.columns") {
      columns = newValue;
      rows = form.values.layout.rows || 1;
    }
    const updatedViewportList = [...viewportList];
    const validCombinations = new Set();
    
    for(let i = 1; i <= rows; i++) {
      for(let j = 1; j <= columns; j++) {
        // Add all valid (i, j) combinations to the set
        validCombinations.add(`${i}-${j}`);

        // Check if the current combination exists in the array
        const exists = updatedViewportList.some(
          viewport => parseInt(viewport.row,10) === i && parseInt(viewport.column) === j
        );

        if (!exists) {
          // Add missing (i, j) combination as a new viewport
          updatedViewportList.push(
            { 
              row: i,
              column: j,
              windowWidth: "",
              windowLevel: "",
              flipVertically: HP_VIEWPORT_FLIP.DISABLE,
              flipHorizontally: HP_VIEWPORT_FLIP.DISABLE,
              alignment: HP_VIEWPORT_ALIGNMENT.CENTER,
              rotation: "",
              seriesConditions: [
                { tag: "", operand: "", value: [] },
              ],
              imageConditions: [
                { tag: "", operand: "", value: [] },
              ],
            });
        }
      }
    }
    const filteredViewports = updatedViewportList.filter((viewport) =>
      validCombinations.has(`${viewport.row}-${viewport.column}`)
    );
    updateViewportList(filteredViewports);
  };

  const errorMessage = getIn(props.allErrors, field.name);
    
  return (
    <div className={"form-field ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12"}>
      <label className="ms-Label custom-label">{props.label}</label>
      <SpinButton
        name={field.name}
        value={field.value?.toString() || "0"}
        min={1}
        max={3}
        step={1}
        incrementButtonAriaLabel="Increase value"
        decrementButtonAriaLabel="Decrease value"
        onChange={onChange}
        styles={customSpinButtonStyles}
        errorMessage={errorMessage}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

const {
  values,
} = props.formik;

const updateViewportList = (newViewportList) => {
  props.formik.setFieldValue("layout.viewportList", newViewportList);
};

return (
  <FormikProvider value={props.formik}>
    <Form>
    <div className="tab-section">
      <div>
      <div className="form-section-header">
        <p>{t("hanging-protocol.layout")}</p>
      </div>
      {(props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT) &&
        <div className="ms-Grid" dir="ltr">

          <div className="ms-Grid-row">
              <Field
                name="layout.name"
                value={values.layout.name}
                placeholder={t("hanging-protocol.name")}
                label={t("hanging-protocol.name")}
                parentClassName={"form-field ms-Grid-col ms-sm12 ms-md3 ms-lg3"}
                component={FormikATextField}
                autoFocus={true}
                allErrors={props.allErrors}
                required={true}
              />
          </div>

          <div className="ms-Grid-row" style={{marginTop:"20px"}}>
            <div className="ms-Grid-col"  style={{ paddingLeft: "0px" }}>
                <Field
                  name="layout.rows"
                  value={values.layout.rows}
                  placeholder={t("hanging-protocol.rows")}
                  label={t("hanging-protocol.rows")}
                  parentClassName={"form-field ms-sm12 ms-md3 ms-lg3"}
                  viewportList={values.layout.viewportList || []}
                  updateViewportList={updateViewportList}
                  component={ViewportCntTextField}
                  allErrors={props.allErrors}
                />
              </div>
              <div className="ms-Grid-col">
                <Field
                  name="layout.columns"
                  value={values.layout.columns}
                  label={t("hanging-protocol.columns")}
                  placeholder={t("hanging-protocol.columns")}
                  parentClassName={"form-field ms-sm12 ms-md3 ms-lg3"}
                  viewportList={values.layout.viewportList || []}
                  updateViewportList={updateViewportList}
                  component={ViewportCntTextField}
                  allErrors={props.allErrors}
                />
              </div>
            </div>
          {/* <div className="ms-Grid-row" style={{marginTop:"20px"}}>
            <FieldArray
              name="layout.viewportList"
              render={arrayHelpers => (
              <>
              
              <div className="ms-Grid-row">
                <Accordion collapsible>
                  {values.layout.viewportList && values.layout.viewportList.length > 0  && values.layout.viewportList.map((viewport, index) => (
                    <AccordionItem key={index} value={index}>
                    <AccordionHeader className="accordion-header" >{`${t("hanging-protocol.viewport")} ${viewport.row} X ${viewport.column}`}</AccordionHeader>
                    <AccordionPanel className="accordion-panel">
                    <Viewport
                        formik = { props.formik }
                        seriesConditionMetaTagOptions = {props.seriesConditionMetaTagOptions}
                        imageConditionMetaTagOptions = {props.imageConditionMetaTagOptions}
                        conditionOperandOptions = {props.conditionOperandOptions}
                        viewportFlipOptions = {props.viewportFlipOptions}
                        viewportAlignmentOptions = {props.viewportAlignmentOptions}
                        viewportIndex = { index }
                        action={props.action}
                        allErrors={props.allErrors}
                      />
                    </AccordionPanel>
                    </AccordionItem>  
                  ))}
                </Accordion>
              </div>
            </>
            )}/>
          </div> */}

          <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
          {values.layout.viewportList && values.layout.viewportList.length > 0 && (
            <Tabs>
              <TabList>
                {values.layout.viewportList.map((viewport, index) => (
                  <Tab key={index}>{`${t("hanging-protocol.viewport")} ${viewport.row} X ${viewport.column}`}</Tab>
                ))}
              </TabList>

              {values.layout.viewportList.map((viewport, index) => (
                <TabPanel key={index}>
                  <Viewport
                    formik={props.formik}
                    seriesConditionMetaTagOptions={props.seriesConditionMetaTagOptions}
                    imageConditionMetaTagOptions={props.imageConditionMetaTagOptions}
                    conditionOperandOptions={props.conditionOperandOptions}
                    viewportFlipOptions={props.viewportFlipOptions}
                    viewportAlignmentOptions={props.viewportAlignmentOptions}
                    viewportIndex={index}
                    action={props.action}
                    allErrors={props.allErrors}
                  />
                </TabPanel>
              ))}
            </Tabs>
          )}
        </div>
         
        </div>
      }
      { props.action === ACTIONS.VIEW &&
        <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <div className="form-heading">{t("hanging-protocol.name")}</div>
          <div className="form-mt-10">{values.layout.name}</div>
          
        </div>
        <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
          <div className="ms-Grid-col" style={{ paddingLeft: "0px" }}>
            <div className="form-heading">{t("hanging-protocol.rows")}</div>
            <div className="form-mt-10">{values.layout.rows}</div>
          </div>
          <div className="ms-Grid-col" >
            <div className="form-heading">{t("hanging-protocol.columns")}</div>
            <div className="form-mt-10">{values.layout.columns}</div>
          </div>
        </div>
        <FieldArray
          name="layout.viewportList"
          render={arrayHelpers => (
            <>
           
            {/* <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <Accordion collapsible>
                {values.layout.viewportList && values.layout.viewportList.length > 0  && values.layout.viewportList.map((viewport, index) => (
                  <AccordionItem key={index} value={index}>
                  <AccordionHeader className="accordion-header">{`${t("hanging-protocol.viewport")} ${viewport.row} X ${viewport.column}`}</AccordionHeader>
                  <AccordionPanel className="accordion-panel">
                  <Viewport
                      formik = { props.formik }
                      viewportIndex = { index }
                      action={props.action}
                    />
                  </AccordionPanel>
                  </AccordionItem>  
                ))}
              </Accordion>
            </div> */}

            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              {values.layout.viewportList && values.layout.viewportList.length > 0 && (
                <Tabs>
                  <TabList>
                    {values.layout.viewportList.map((viewport, index) => (
                      <Tab key={index}>{`${t("hanging-protocol.viewport")} ${viewport.row} X ${viewport.column}`}</Tab>
                    ))}
                  </TabList>

                  {values.layout.viewportList.map((viewport, index) => (
                    <TabPanel key={index} className="tab-panel">
                      <Viewport
                        formik={props.formik}
                        viewportIndex={index}
                        action={props.action}
                      />
                    </TabPanel>
                  ))}
                </Tabs>
              )}
            </div>

          </>
          )}/>
      </div>
    
      }   
    </div>
    </div>
  </Form>
  </FormikProvider>
  );
};

export default Layout;
